import { NoonReportSectionEnum } from '../types/BusinessModel/AolEnums';
import { AolSectionDataUpdateDto } from '../types/Dto/AolSectionDataUpdateDto';

export class AolSectionDataUpdateDtoFactory {
    public createDto(
        imoNumber: number,
        noonReportSectionEnum: NoonReportSectionEnum,
        isAolCompleted: boolean,
        isAolApproved: boolean,
        isSectionCompleted: boolean,
        isSectionApproved: boolean,
        noonReportGuid?: string
    ): AolSectionDataUpdateDto {
        return {
            imoNumber: imoNumber,
            noonReportSectionEnum: noonReportSectionEnum,
            isAolCompleted: isAolCompleted,
            isAolApproved: isAolApproved,
            isSectionCompleted: isSectionCompleted,
            isSectionApproved: isSectionApproved,
            noonReportGuid: noonReportGuid,
        };
    }
}
